import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6379ed7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "tabContainer",
  class: "tab-container"
}
const _hoisted_2 = {
  ref: "tabBar",
  class: "tab-bar"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  style: {"width":"24px","height":"24px"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  style: {"pointer-events":"none"},
  class: "tab-text no-select"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: label,
          class: "tab active",
          onClick: () => _ctx.changeTab(label)
        }, [
          (_ctx.icons != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  style: {"pointer-events":"none"},
                  src: _ctx.icons[_ctx.labels.indexOf(label)]
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, _toDisplayString(label), 1)
        ], 8, _hoisted_3)), [
          [_vShow, !_ctx.hiddenIndexes.includes(_ctx.labels.indexOf(label))]
        ])
      }), 128)),
      _hoisted_7
    ], 512)
  ], 512))
}